'use client';

import { useEffect, useState } from 'react';

const BlurredContent = ({ content, isSession }) => {
  const [blurredContent, setBlurredContent] = useState(content);

  useEffect(() => {
    if (!isSession) {
      setBlurredContent(content);
    } else {
      setBlurredContent(content.replace(/<\/?code>/g, ''));
    }
  }, [isSession, content]);

  return (
    <div
      className="post-content mt-5"
      dangerouslySetInnerHTML={{ __html: blurredContent }}
    />
  );
};

export default BlurredContent;